export default "__VITE_ASSET__Di5CC7iq__"